<script setup lang="ts">
import ListSearchCommon from 'src/components/ListSearchCommon.vue';
import PeopleCard from 'src/components/search-results/PeopleCard.vue';
import ProjectCard from 'src/components/search-results/ProjectCard.vue';
import SceneCard from 'src/components/search-results/SceneCard.vue';
import PeopleSkeleton from 'src/components/skeleton-loading/PeopleSkeleton.vue';
import type { PeopleCardData } from 'src/types';
import type { ProjectCardData } from 'src/types/entity.types';
import type { RecentAccessedData } from 'src/types/recent-accessed.types';
import type { SceneCardDataType } from 'src/types/scene.types';

type CR = RecentAccessedData;
const convertData = (data: RecentAccessedData) => {
    type R =
        | {
              type: 'people';
              data: PeopleCardData | undefined;
          }
        | {
              type: 'entity';
              data: ProjectCardData | undefined;
          }
        | {
              type: 'item';
              data: SceneCardDataType | undefined;
          };
    const result: R = {
        type: data.type,
        data: undefined
    };

    switch (data.type) {
        case 'people':
            result.data = data?.ws_user_role;
            break;
        case 'entity':
            result.data = data?.entity;
            break;
        case 'item':
            result.data = data?.item;
            break;
    }
    return result;
};
function convertToSceneData(data: RecentAccessedData) {
    const result = convertData(data);
    return result.data as SceneCardDataType;
}
function convertToPeopleData(data: RecentAccessedData) {
    const result = convertData(data);
    return result.data as PeopleCardData;
}
function convertToProjectData(data: RecentAccessedData) {
    const result = convertData(data);
    return result.data as ProjectCardData;
}
</script>

<template>
    <ListSearchCommon :key="'recent_accessed'" type="recent_accessed">
        <template #item="{ data }">
            <PeopleCard v-if="(data as CR).type == 'people'" :data="convertToPeopleData(data as CR)" />
            <ProjectCard v-if="(data as CR).type == 'entity'" :data="convertToProjectData(data as CR)" />
            <SceneCard v-if="(data as CR).type == 'item'" :data="convertToSceneData(data as CR)" />
        </template>

        <template #skeleton-loading>
            <PeopleSkeleton />
        </template>
    </ListSearchCommon>
</template>
